import { defineStore } from "pinia"
import baseAPI from "@/stores/base-api"

export const useAuthStore = defineStore("auth", {
  state: () => ({
    errMsg: "",
    userInfo: null,
    token: localStorage.getItem('user-token'),
    permissions: ['all', 'noauth'],
    notice_unread: 0,
  }),
  actions: {
    async loginHandler(email, password) {
      await baseAPI().post("/profiles/login", { login: email, password: password})
        .then((data) => {
          this.errMsg = '';
          this.token = data.data.token;
          localStorage.setItem('user-token', this.token); // store the token in localstorage
        })
        .catch((error) => {
          this.errMsg = 'Не верные логин или пароль';
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.errMsg = error.response.data.Exception.message;
          }
          this.userLogOut();
        })
        await this.getCurrentUser(true);
        if (!this.isAuthenticated) {
          if (!this.errMsg) {
            this.errMsg = 'Не удалось выполнить вход в ЛК. Попробуйте позднее.';
          }
        }
    },
    async getCurrentUser(updateInfo = false) {

      if (!this.token) return true;
      if (!this.userInfo) { updateInfo = true; }
      if (!updateInfo) return true;

      await baseAPI().get("/profiles/profile")
        .then((data) => {
          this.userInfo = data.data;
        })
        .catch((error) => {
          this.userLogOut();
          return false;
        }
      );

      this.permissions = ['all', 'auth'];
      this.notice_unread = 0;

      await baseAPI().get("/notices/unreaded")
        .then((data) => {
          this.notice_unread = data.data.count;
        })
        .catch((error) => {
          return false;
        }
      );
    },
    userLogOut() {
      this.token = null;  
      localStorage.removeItem('user-token') // clear your user's token from localstorage
      this.userInfo = null;
      this.permissions = ['all', 'noauth'];
    },
    setToken(token) {
      this.token = token;
      localStorage.setItem('user-token', this.token)
    },
  },
  getters: {
    isAuthenticated: state => !!state.token,
    accountCount(state) {
      return state.account_list.length;
    }
  }
});
